import { baseQuerySetup,getResponsedata,onQueryStarted, onCacheEntryAdded } from 'config/index';
import { createApi } from '@reduxjs/toolkit/query/react';
import { COMPANY_PREFIX } from 'constants/index';
import { setNavLoader } from './App.service';
import { consumerApi } from './consumer.service';
import { realtorApi } from './realtor.service';
import { getPrefixFromUserType , getApiPrefixFromUserType } from 'utils/roles';
// THE REDUCER DEFINATION
let DocumentReducer = 'DocumentReducer';
let DocumentTag = 'DocumentTag';

// DOCUMENT API
export const documentApi = createApi({
    reducerPath: DocumentReducer,
    baseQuery: baseQuerySetup,
    tagTypes: [DocumentTag],
    endpoints: (builder) => ({
        DocumentToJson: builder.mutation({
            query: ({ body , USERTYPE }) => {
                let prefix = getApiPrefixFromUserType(USERTYPE);
                return { url: `/pre-added${prefix}/upload`, Credential: 'include' , method: 'POST', body };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata
        }),
        getDocumenturl: builder.mutation({
            query: (body) => {
                return { url: COMPANY_PREFIX + '/docs-resolution' , method: 'POST', body };
            },
            onQueryStarted,
            onCacheEntryAdded,
            transformResponse: getResponsedata
        }),
        UpdateAvatar: builder.mutation({
            query: ({ id , body , USERTYPE }) => {
                const prefix = getPrefixFromUserType(USERTYPE);
                return { url: prefix + '/' + id + '/avatar', body, method: 'PUT' };
            },
            async onQueryStarted({ id }, { dispatch , queryFulfilled }) {
                try {
                    dispatch(setNavLoader(true));
                    await queryFulfilled;
                    dispatch(consumerApi.util.updateQueryData('getConsumerDetails',{ id } ,(draft) => {
                        draft.authData.isTwoMfaEnable = false;
                    }));
                    dispatch(realtorApi.util.updateQueryData('getRealtorDetails',{ id } ,(draft) => {
                        draft.authData.isTwoMfaEnable = false;
                    }));

                    dispatch(setNavLoader(false));
                } catch (error) {
                    dispatch(setNavLoader(false));
                }
            },
            onCacheEntryAdded,
            transformResponse: getResponsedata
        })

    })
});
export const { useGetDocumenturlMutation, useDocumentToJsonMutation, useUpdateAvatarMutation } = documentApi;
